import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Button, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, Grid, TextField } from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import UserInfo from "src/components/common/UserInfo";
import PaymentCodeDialog from "src/components/dialogs/PaymentCodeDialog";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import Confirm from "src/components/common/ConfirmDialog";
import ChannelAddDialog from "./components/ChannelAddDialog";
import MerchantInfo from "src/components/common/MerchantInfo";
import SpeakerAddDialog from "./components/SpeakerAddDialog";

const TABLE_HEAD = [
  { id: "mid", label: "商户", alignRight: false }, 
  { id: "sn", label: "编码", alignRight: false }, 
  // { id: "status", label: "状态", alignRight: false }, 
  { id: "createdAt", label: "创建时间", alignRight: false }, 
  { id: "操作" }
];

const moreMenus = [
  { title: "测试播报", icon: iconEdit2 },
  { title: "删除", icon: iconEdit2 },
];

export default function MerchantSpeaker() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [targetMerchant, setTargetMerchant] = useState(null);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [targetItem, setTargetItem] = useState({});

  const [action, setAction] = useState("");

  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/merchant/speaker/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/merchant/edit/${row.mid}`, { state: row });
      setTargetItem(row);
      setAction("edit");
    } else if (type === "删除") {
      handleDelItem(row.id);
    } else if (type === "测试播报") {
      handleTestSpeaker(row.mid);
    } 

  };

  function handleDelItem(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      async onConfirm() {
        const { data } = await asyncRequest({
          path: "/merchant/speaker/del",
          data: { id },
        });

        setItems(items.filter((b) => b.id !== id));
      },
    });
  }

  
  async function handleTestSpeaker(mid) {
    const { data } = await asyncRequest({
      path: "/merchant/speaker/test",
      data: {
        mid,
      },
    });

    alert('测试成功', 'success');
  }

  async function toggleEnabled(mid) {
    const { data } = await asyncRequest({
      path: "/merchant/speaker/toggleEnabled",
      data: {
        mid,
      },
    });

    const item = items.find((it) => it.mid == mid);
    item.isEnabled = !item.isEnabled;
    setItems([...items]);
  }

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }

  const isUserNotFound = items.length === 0;

  return (
    <>
      <Page title="播报器">
        <Container maxWidth="2000px">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              播报器
            </Typography>

            <Button
              variant="contained"
              startIcon={<Icon icon={plusFill} />}
              onClick={() => {
                setAction("add");
              }}
            >
              添加播报器
            </Button>
          </Stack>

          <Card>
            <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems}>
              <Grid container>
                <Grid item>
                  <TextField
                    style={{ width: 200 }}
                    label="商户名称"
                    placeholder="商户名称"
                    autoComplete="off"
                    id="merchantName"
                    size="small"
                    value={filter.merchantName}
                    onChange={(e) => {
                      handleFilterChange("merchantName", e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
            </ListToolbar>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <ListHead headLabel={TABLE_HEAD} />
                  <TableBody>
                    {items.map((row) => {
                      const { mid, sn, merchant, realname, createdAt } = row;
                      const isItemSelected = selected.indexOf(realname) !== -1;

                      return (
                        <TableRow hover key={mid} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                          {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, mid)}
                            />
                          </TableCell> */}
                          <TableCell align="left">{merchant ? <MerchantInfo {...merchant} /> : null}</TableCell>
                          <TableCell align="left">{sn}</TableCell>
                          {/* <TableCell align="left">
                            <Label variant="ghost" color={["error", "success"][status]}>
                              {["未开户", "已开户"][status]}
                            </Label>
                          </TableCell> */}
                          <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                          <TableCell align="right">
                            <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                          <SearchNotFound searchQuery={filter.search} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
          </Card>
        </Container>

        {/* <FormDialog title={action === "add" ? "添加分类" : "修改分类"} open={!!action} onClose={() => setAction()} onConfirm={handleDialogConfirm}>
        <FormItem title="分类名称" required>
          <TextField fullWidth placeholder="请输入分类名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
        </FormItem>

        <FormItem title="分类状态" required>
          <Switch checked={form.isShow} onChange={(e) => handleIptChange("isShow", e.target.checked)} />
        </FormItem>
      </FormDialog> */}

        {!!targetMerchant && <PaymentCodeDialog open={true} merchant={targetMerchant} onClose={() => setTargetMerchant(null)} />}
        {(action === "add" || action === "edit") && (
          <SpeakerAddDialog
            item={targetItem}
            open
            onClose={() => setAction("")}
            onUpdate={() => {
              getItems();
              setAction("");
            }}
          />
        )}
      </Page>
    </>
  );
}
